import { useState } from 'react';

interface DropdownOpenTransitionCallbacks {
  onOpen?: () => void;
  onClose?: () => void;
}

/**
 * Runs onOpen/onClose exactly once per open-state transition, including
 * transitions a coordinator triggers (e.g. closing this dropdown because a
 * sibling opened) that don't go through this dropdown's own close handler.
 * Adjusts state during render (React's recommended pattern) instead of a
 * useEffect to avoid an extra render pass.
 */
export function useDropdownOpenTransition(isOpen: boolean, callbacks?: DropdownOpenTransitionCallbacks): void {
  const [prevIsOpen, setPrevIsOpen] = useState(isOpen);

  if (isOpen !== prevIsOpen) {
    setPrevIsOpen(isOpen);
    if (isOpen) {
      callbacks?.onOpen?.();
    } else {
      callbacks?.onClose?.();
    }
  }
}
